var css = {"icon":"FacebookLogin-module_icon__QW6fW","button":"FacebookLogin-module_button__uxVqD"};

export { css as default };
